var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInovex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D5DFF",
    d: "m13.781 19.825 2.171 8.17a.865.865 0 0 0 .708-.248l11.092-11.18a.86.86 0 0 0 .243-.52l-8.169 2.17-6.045 1.608Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m13.781 19.825 2.171 8.17a.865.865 0 0 0 .708-.248l11.092-11.18a.86.86 0 0 0 .243-.52l-8.169 2.17-6.045 1.608Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#13A3A3",
    d: "m15.952 27.997-2.17-8.17-1.607-6.046-8.17 2.171a.862.862 0 0 0 .248.709l1.832 1.818 9.348 9.275a.86.86 0 0 0 .518.242h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m15.952 27.997-2.17-8.17-1.607-6.046-8.17 2.171a.862.862 0 0 0 .248.709l1.832 1.818 9.348 9.275a.86.86 0 0 0 .518.242h.001Z",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7DF481",
    d: "m12.175 13.78 6.045-1.606-2.17-8.168a.863.863 0 0 0-.71.247l-4.377 4.414-6.712 6.766a.855.855 0 0 0-.243.518l8.168-2.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m12.175 13.78 6.045-1.606-2.17-8.168a.863.863 0 0 0-.71.247l-4.377 4.414-6.712 6.766a.855.855 0 0 0-.243.518l8.168-2.17Z",
    opacity: 0.32,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0AAFE8",
    d: "M27.745 15.336 16.565 4.243A.86.86 0 0 0 16.047 4l2.17 8.17 1.608 6.045 8.168-2.17a.864.864 0 0 0-.247-.709h-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M27.745 15.336 16.565 4.243A.86.86 0 0 0 16.047 4l2.17 8.17 1.608 6.045 8.168-2.17a.864.864 0 0 0-.247-.709h-.001Z",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24.094,
    x2: 14.662,
    y1: 21.324,
    y2: 24.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172E9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.452,
    x2: 8.181,
    y1: 23.947,
    y2: 15.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F2F3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D1D6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#9CA6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#5364B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#172E9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.138,
    x2: 19.134,
    y1: 9.919,
    y2: 7.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C1DACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#277F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#006837"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.162,
    x2: 23.852,
    y1: 6.664,
    y2: 16.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EAECF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D1D6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AEB6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#818EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#4B5DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172E9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInovex);
export default __webpack_public_path__ + "static/media/inovex.462171363a540bf1b7c9bc73920c5a15.svg";
export { ForwardRef as ReactComponent };